import React from 'react'
import { useTranslation } from 'react-i18next'

import AgendaTable from 'components/organisms/AgendaTable'
import PageTitle from 'components/atoms/PageTitle'

export default function Agenda() {
  const { t } = useTranslation()

  return (
    <div className="content-container">
      <PageTitle label={t('agenda.title')} />
      <AgendaTable />
    </div>
  )
}
